import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import steps from '../../survey/steps';

function StepWrapper(props) {
  const currentStep = useSelector((state) => state.steps.currentStep);
  const stepName = props.stepData.name;
  const { customIsCompletedValidation } = props;
  const questions = useSelector((state) => state.questions.list);
  const stepsList = useSelector((state) => state.steps.list);
  const isThisPreviousStep = useSelector((state) => state.steps.previousStep) === stepName;
  const isThisCurrentStep = currentStep === stepName;
  const isThisNextStep = useSelector((state) => state.steps.nextStep) === stepName;
  const isItSingleQuestionStep = props.questions && props.questions.length === 1;
  const [isCurrentStepCompleted, setCurrentStepCompleted] = useState(false);
  const [thisStep, setThisStep] = useState(null);

  useEffect(() => {
    if (customIsCompletedValidation) return;

    thisStep && steps.setStepStatus({
      stepName: thisStep.name,
      stepStatus: isCurrentStepCompleted,
    });
  }, [isCurrentStepCompleted, currentStep]);

  useEffect(() => {
    stepsList.forEach((step) => {
      if (props.stepData.name === step.name) {
        setThisStep(step);
      }
    });
  }, []);

  useEffect(() => {
    if (customIsCompletedValidation && thisStep && isCurrentStepCompleted !== steps.getStepStatus({ stepName: thisStep.name })) {
      setCurrentStepCompleted(steps.getStepStatus({ stepName: thisStep.name }));
    }
  });

  function checkIfOneAnswerSelected(answers) {
    if (Object.keys(answers).length > 0) {
      return true;
    }

    if (Object.keys(answers).length <= 0) {
      return false;
    }
  }

  function checkIfAtLeastThreeAnswerSelected(answers) {
    if (Object.keys(answers).length > 2) {
      return true;
    }

    if (Object.keys(answers).length <= 2) {
      return false;
    }
  }

  if (isItSingleQuestionStep && !customIsCompletedValidation && props.questions) {
    const isCompletedLogicType = props.questions[0].isCompleted;
    const { answers } = questions[props.questions[0].name];

    if (isCompletedLogicType === 'ifOneAnswerSelected' && checkIfOneAnswerSelected(answers) !== isCurrentStepCompleted) {
      setCurrentStepCompleted(checkIfOneAnswerSelected(answers));
    }

    if (isCompletedLogicType === 'ifAtLeastThreeAnswerSelected' && checkIfAtLeastThreeAnswerSelected(answers) !== isCurrentStepCompleted) {
      setCurrentStepCompleted(checkIfAtLeastThreeAnswerSelected(answers));
    }
  }

  if (!isItSingleQuestionStep && !customIsCompletedValidation && props.questions) {
    const allCompletedArr = [];
    let allCompleted = true;

    props.questions.forEach((question, index) => {
      const isCompletedLogicType = question.isCompleted;
      const { answers } = questions[question.name];

      if (isCompletedLogicType === 'ifOneAnswerSelected') {
        const isCompleted = checkIfOneAnswerSelected(answers);
        allCompletedArr[index] = isCompleted;
      }

      if (isCompletedLogicType === 'ifAtLeastThreeAnswerSelected') {
        const isCompleted = checkIfAtLeastThreeAnswerSelected(answers);
        allCompletedArr[index] = isCompleted;
      }

      for (let i = 0; i < allCompletedArr.length; i++) {
        if (allCompletedArr[i] === false) {
          allCompleted = false;
          break;
        }
      }
    });

    if (allCompleted !== isCurrentStepCompleted) {
      setCurrentStepCompleted(allCompleted);
    }
  }

  return (
    <>
      {
        React.cloneElement(props.children, {
          stepData: props.stepData,
          isThisPreviousStep,
          isThisCurrentStep,
          isThisNextStep,
          isCurrentStepCompleted,
          design: props.design,
          otherProps: props,
        })
      }
    </>
  );
}

export default StepWrapper;
